import { theme } from '@frontend/theme';

export const chartColors = {
  'net-total': theme.colors.success50,
  'fees-total': theme.colors.neutral20,
  'refund-total': theme.colors.critical50,
  paid: theme.colors.success40,
  outstanding: theme.colors.warning50,
};
